var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { providers } from "ethers";
import Web3Modal from "web3Modal";
import * as React from "react";
import { useEffect, useState, useReducer } from "react";
import reducer from "../helpers/reducer";
import initialWalletControllerState from "../constants/initialWalletControllerState";
import { MetamaskProviderOptions, WalletConnectProviderOptions, TorusProviderOptions, } from "../constants/providerOptions";
import ModalButton from "./ModalButton";
import Torus from "@toruslabs/torus-embed";
import initialTorusWalletControllerState from "../constants/initialTorusControllerState";
import torusReducer from "../helpers/torusReducer";
import WalletType from "../types/walletTypes";
var WalletController = function (props) {
    var _a;
    // Modal state handler
    var _b = useReducer(reducer, initialWalletControllerState), state = _b[0], dispatch = _b[1];
    // State handler specific to Torus
    var _c = useReducer(torusReducer, initialTorusWalletControllerState), torusState = _c[0], torusDispatch = _c[1];
    var _d = useState(false), isTorus = _d[0], setIsTorus = _d[1];
    var _e = useState(null), web3Modal = _e[0], setWeb3Modal = _e[1];
    var _f = useState(), torusProvider = _f[0], setTorusProvider = _f[1];
    var _g = useState(false), waitingForWalletSign = _g[0], setWaitingForWalletSign = _g[1];
    var provider = state.provider, web3Provider = state.web3Provider, address = state.address, chainId = state.chainId;
    var ethersProvider = torusState.ethersProvider, torusAddress = torusState.torusAddress, torusChainId = torusState.torusChainId;
    /**
     * Record object of a wallet type mapped to a specific wallet config ~
     * Metamask and walletconnect have separate provider options,
     * Torus requires the injected provider to be disabled
     */
    var web3ModalConfig = (_a = {},
        _a[WalletType.Metamask] = {
            providerOptions: MetamaskProviderOptions,
        },
        _a[WalletType.Torus] = {
            disableInjectedProvider: true,
        },
        _a[WalletType.WalletConnect] = {
            providerOptions: WalletConnectProviderOptions,
            disableInjectedProvider: true,
        },
        _a);
    // useEffect to initialise modal
    useEffect(function () {
        if (typeof window !== "undefined" && !web3Modal) {
            var modal = new Web3Modal({
                cacheProvider: false,
                providerOptions: WalletConnectProviderOptions, // required
            });
            setWeb3Modal(modal);
        }
    }, [web3Modal, setWeb3Modal]);
    // handles when the user changes accounts in their wallet
    useEffect(function () {
        if (provider === null || provider === void 0 ? void 0 : provider.on) {
            var handleAccountsChanged_1 = function (accounts) {
                // eslint-disable-next-line no-console
                console.log("accountsChanged", accounts);
                dispatch({
                    type: "SET_ADDRESS",
                    address: accounts[0],
                });
            };
            var handleChainChanged_1 = function (_hexChainId) {
                window.location.reload();
            };
            var handleDisconnect_1 = function (error) {
                // eslint-disable-next-line no-console
                console.log("disconnect", error);
                disconnect();
            };
            provider.on("accountsChanged", handleAccountsChanged_1);
            provider.on("chainChanged", handleChainChanged_1);
            provider.on("disconnect", handleDisconnect_1);
            // Subscription Cleanup
            return function () {
                if (provider.removeListener) {
                    provider.removeListener("accountsChanged", handleAccountsChanged_1);
                    provider.removeListener("chainChanged", handleChainChanged_1);
                    provider.removeListener("disconnect", handleDisconnect_1);
                }
            };
        }
    }, [provider]);
    /**
     * Connection setup for the torus wallet, takes torus specific providers
     */
    var connectTorus = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _torus, web3Provider, signer, address, network;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _torus = new Torus();
                    return [4 /*yield*/, _torus.init(TorusProviderOptions)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, _torus.login()];
                case 2:
                    _a.sent();
                    web3Provider = new providers.Web3Provider(_torus.provider);
                    setTorusProvider(web3Provider);
                    signer = web3Provider.getSigner();
                    return [4 /*yield*/, signer.getAddress()];
                case 3:
                    address = _a.sent();
                    return [4 /*yield*/, web3Provider.getNetwork()];
                case 4:
                    network = _a.sent();
                    // needed for signer using torus provider params
                    setIsTorus(true);
                    props.setUserWalletAddress(address);
                    props.switchingWallet(true);
                    sessionStorage.setItem("connected", "true");
                    torusDispatch({
                        type: "SET_WEB3_PROVIDER",
                        ethersProvider: web3Provider,
                        torusAddress: address,
                        torusChainId: network.chainId,
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * Connection setup for Metamask
     */
    var connectMetamask = function () { return __awaiter(void 0, void 0, void 0, function () {
        var modal, provider, web3Provider, signer, address, network;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    modal = new Web3Modal(web3ModalConfig[WalletType.Metamask]);
                    return [4 /*yield*/, modal.connect()];
                case 1:
                    provider = _a.sent();
                    web3Provider = new providers.Web3Provider(provider);
                    signer = web3Provider.getSigner();
                    return [4 /*yield*/, signer.getAddress()];
                case 2:
                    address = _a.sent();
                    return [4 /*yield*/, web3Provider.getNetwork()];
                case 3:
                    network = _a.sent();
                    props.switchingWallet(true);
                    props.setUserWalletAddress(address);
                    sessionStorage.setItem("connected", "true");
                    dispatch({
                        type: "SET_WEB3_PROVIDER",
                        provider: provider,
                        web3Provider: web3Provider,
                        address: address,
                        chainId: network.chainId,
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * Connection setup for WalletConnect, takes WalletConnect specific providers
     */
    var connectWalletConnect = function () { return __awaiter(void 0, void 0, void 0, function () {
        var modal, provider, web3Provider, signer, address, network;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    modal = new Web3Modal(web3ModalConfig[WalletType.WalletConnect]);
                    return [4 /*yield*/, modal.connect()];
                case 1:
                    provider = _a.sent();
                    web3Provider = new providers.Web3Provider(provider);
                    signer = web3Provider.getSigner();
                    return [4 /*yield*/, signer.getAddress()];
                case 2:
                    address = _a.sent();
                    return [4 /*yield*/, web3Provider.getNetwork()];
                case 3:
                    network = _a.sent();
                    props.switchingWallet(true);
                    props.setUserWalletAddress(address);
                    sessionStorage.setItem("connected", "true");
                    dispatch({
                        type: "SET_WEB3_PROVIDER",
                        provider: provider,
                        web3Provider: web3Provider,
                        address: address,
                        chainId: network.chainId,
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * Disconnect button that disconnects and removes user details from shopify/database
     */
    var disconnect = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, web3Modal.clearCachedProvider()];
                case 1:
                    _a.sent();
                    sessionStorage.setItem("connected", "false");
                    if (!((provider === null || provider === void 0 ? void 0 : provider.disconnect) && typeof provider.disconnect === "function")) return [3 /*break*/, 3];
                    return [4 /*yield*/, provider.disconnect()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    props.setUserWalletAddress("");
                    props.connectedWallet(false);
                    dispatch({
                        type: "RESET_WEB3_PROVIDER",
                    });
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * Called when user clicks sign Message button. waits for user to sign message, then it
     * sends a request to the backend with their customerid, wallet address and the message signature
     * signature now includes a customerID and expiry limit
     */
    var signMessage = function () { return __awaiter(void 0, void 0, void 0, function () {
        var customerID, expiry, itemToSign, domain, types, signer, signature;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setWaitingForWalletSign(true);
                    customerID = parseInt(document.getElementById("customerId").textContent, 10);
                    expiry = Math.floor(Date.now() / 1000) + 600;
                    itemToSign = {
                        customerID: customerID,
                        expiry: expiry,
                    };
                    domain = {
                        name: "Cloud9 Shopify Signature",
                    };
                    types = {
                        types: [
                            { name: "customerID", type: "uint256" },
                            { name: "expiry", type: "uint256" },
                        ],
                    };
                    if (isTorus) {
                        signer = torusProvider.getSigner();
                    }
                    else {
                        signer = web3Provider.getSigner();
                    }
                    return [4 /*yield*/, signer._signTypedData(domain, types, itemToSign)];
                case 1:
                    signature = _a.sent();
                    props.setExpiry(expiry);
                    props.setSignedMessage(signature);
                    setWaitingForWalletSign(false);
                    return [2 /*return*/];
            }
        });
    }); };
    return web3Provider || ethersProvider ? (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { display: "flex", flexDirection: "column" } }, props.isCloudKeyHolder && (React.createElement(React.Fragment, null,
            React.createElement("p", { style: {
                    margin: "1.5em 0em 1em 0em",
                } }, "In order to confirm this is your address, you'll have to sign a message. Connecting an empty wallet does not entitle you to any benefits."),
            React.createElement("p", { style: {
                    fontSize: "12px",
                    color: "#2a2a2a",
                } }, "This won't cost you any fees or crypto, it's just an extra step to validate your CloudKey"),
            React.createElement("button", { className: "ProductForm__AddToCart Button Button--primary Button--full", onClick: signMessage }, "Confirm Wallet"),
            waitingForWalletSign && (React.createElement("p", null, "Go to your wallet app and sign the message we just sent!"))))),
        React.createElement("div", { style: { display: "flex", marginTop: "8px" } },
            React.createElement(ModalButton, { connectMetamask: connectMetamask, connectWalletConnect: connectWalletConnect, connectTorus: connectTorus, buttonContent: "Link Another Wallet" })))) : (React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
        React.createElement("div", null, props.customerWalletAddress ? (React.createElement(React.Fragment, null,
            React.createElement(ModalButton, { connectMetamask: connectMetamask, connectWalletConnect: connectWalletConnect, connectTorus: connectTorus, buttonContent: "Link Another Wallet" }),
            React.createElement("button", { className: "ProductForm__AddToCart Button Button--primary Button--full", onClick: function () { return disconnect(); }, style: { marginTop: "1rem" }, disabled: !web3Modal }, "Disconnect Wallet"))) : (React.createElement(ModalButton, { connectMetamask: connectMetamask, connectWalletConnect: connectWalletConnect, connectTorus: connectTorus, buttonContent: "Link Your Wallet" })))));
};
export default WalletController;
